module.exports = __webpack_public_path__ + "static/media/realtor.42dd06cd.png";